import React from "react";
import { useSelector } from 'react-redux';
import { Card, CardContent } from "../../ui/card";
import { Loader, CheckCircle } from "lucide-react";

const ApplicationStatus = () => {
  const { appUsage, appUsageLoading } = useSelector(state => state.UserStatus);
  const lastStatuses = appUsage?.lastStatuses;

  const getApplicationStatus = (code) => {
    if (!code || (code >= 200 && code < 300)) {
      return 'Reachable';
    }

    if (code >= 300 && code < 400) {
      return 'Not Available';
    }

    if (code >= 400 && code < 500) {
      return 'Not Available';
    }

    return 'Not Reachable';
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-4">
          {appUsageLoading && (<Loader className="h-5 w-5 text-indigo-500 animate-spin" />)}
          {!appUsageLoading && (<CheckCircle className="h-5 w-5 text-indigo-500" />)}
          <h3 className="font-semibold text-lg">Application Status</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead>
              <tr className="text-left text-sm text-gray-500 border-b">
                <th className="py-2 font-medium">Service</th>
                <th className="py-2 font-medium">Status</th>
                <th className="py-2 font-medium">Response Time</th>
                <th className="py-2 font-medium">Status Code</th>
              </tr>
            </thead>
            <tbody>
              {lastStatuses?.map((app, index) => (
                <tr key={index} className="border-b">
                  <td className="py-3 text-sm">{app.appName}</td>
                  <td className="py-3">
                    <div className="flex items-center">
                      <div className={`w-2 h-2 rounded-full mr-2 ${
                        app.reachable ? 'bg-green-500' : 'bg-red-500'
                      }`}></div>
                      <span className="text-sm">{getApplicationStatus(app.httpResponseCode)}</span>
                    </div>
                  </td>
                  <td className="py-3 text-sm">{app.latencyResponse || '0'}ms</td>
                  <td className="py-3 text-sm">{app.httpResponseCode}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApplicationStatus;
